import { env } from "../config/env";
import { getCachedPublicChrome, type PublicChromeConfig } from "../data/cms";

// Payment roadmap:
// - Donations may later point to a PCI-compliant processor checkout or embedded hosted form.
// - Parent tuition, lunch, and fee payments should use an authenticated parent flow.
// - The website must never store card data directly; use processor-hosted payment fields/pages.
// - Processor selection and payment implementation are intentionally out of scope for this scaffold.
function firstConfiguredUrl(...values: Array<string | undefined>) {
  return values.map((value) => String(value || "").trim()).find(Boolean) || "";
}

export function getDonationHref(chrome = getCachedPublicChrome()) {
  return firstConfiguredUrl(chrome?.donationUrl, env.donationUrl) || "/giving";
}

export function getParentPortalHref(chrome = getCachedPublicChrome()) {
  return firstConfiguredUrl(chrome?.parentPortalUrl, env.parentPortalUrl) || "/parents";
}

export function getApplyHref(chrome = getCachedPublicChrome()) {
  return firstConfiguredUrl(chrome?.applyUrl, env.tadsApplyUrl) || "/admissions";
}

export function getPublicSiteLinks(chrome?: PublicChromeConfig | null) {
  return {
    donationHref: getDonationHref(chrome),
    parentPortalHref: getParentPortalHref(chrome),
    applyHref: getApplyHref(chrome),
  };
}
